import { WindowActionType } from '../constant/actionType';

export const windowLoadAction = (context, payload = {}, done) => {
  context.dispatcher.emit(WindowActionType.WINDOW_LOAD, payload);

  if(done) {
    done();
  }
};



// WEBPACK FOOTER //
// ./src/js/app/action/windowLoadAction.js